import { useEffect, useState } from "react";
export const useFading = (
  ref: React.RefObject<HTMLDivElement>,
): [string, boolean] => {
  const [height, setHeight] = useState("100%");
  const [doFade, setDoFade] = useState(false);

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 566px)").matches;
    const isMobileLandscape = window.matchMedia(
      "(min-width: 567px) and (max-width: 767px)",
    ).matches;
    const isTabletPortrait = window.matchMedia(
      "(min-width: 768px) and (max-width: 1023px)",
    ).matches;
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const element = ref.current;
    if (element) {
      const componentHeight = element.clientHeight;
      if (isMobile && componentHeight > 340) {
        setHeight("240px");
        setDoFade(true);
      }

      if (isMobileLandscape && componentHeight > 300) {
        setHeight("240px");
        setDoFade(true);
      }

      if (isTabletPortrait && componentHeight > 320) {
        setHeight("220px");
        setDoFade(true);
      }

      if (isDesktop && componentHeight > 300) {
        setHeight("240px");
        setDoFade(true);
      }
    }
  }, [height, ref]);
  return [height, doFade];
};
